import { render, staticRenderFns } from "./MainSurvey.vue?vue&type=template&id=219f4d98"
import script from "./MainSurvey.vue?vue&type=script&lang=js"
export * from "./MainSurvey.vue?vue&type=script&lang=js"
import style0 from "./MainSurvey.vue?vue&type=style&index=0&id=219f4d98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports